import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  standalone: true,
  imports: [MatIcon, MatTooltip],
  selector: 'app-measurement-analysed-count',
  template: `
    <span>
      @if (isValidCount()) {
        {{ analysedCount }}
      } @else {
        <mat-icon
          aria-label="Invalid analysed count"
          class="warning-icon"
          fontIcon="warning_amber"
          matTooltip="Analysed count is missing or invalid"
        >
        </mat-icon>
      }
    </span>
  `,
})
export class MeasurementAnalysedCountComponent {
  @Input() analysedCount: number | '+';

  isValidCount(): boolean {
    const value = this.analysedCount;
    return value == '+' || (!isNaN(value) && value > 0);
  }
}
